import Dialog from "@mui/material/Dialog";
import type { ContainerItemResponse } from "../../shared/api/requests";
import type { CodeDecoder } from "../scan/scan";
import { ScannerSurface } from "../scan/ScannerSurface";

interface ScanToAddDialogProps {
  open: boolean;
  onClose: () => void;
  containerId: string;
  onItemAdded?: (item: ContainerItemResponse) => void;
  decoder?: CodeDecoder;
}

/**
 * Container-scoped add dialog. The camera, lookup loop, phases and dialog
 * actions live in the shared `container-add` scanner preset (scanner-surface
 * 02); this wrapper owns only the MUI dialog shell.
 */
export function ScanToAddDialog({
  open,
  onClose,
  containerId,
  onItemAdded,
  decoder,
}: ScanToAddDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <ScannerSurface
        variant="container-add"
        containerId={containerId}
        onItemAdded={onItemAdded}
        onClose={onClose}
        decoder={decoder}
      />
    </Dialog>
  );
}
